<template>
  <div
    class="collateral-item"
    :class="{'collateral-item--selected': selected}"
    @click="$emit('click')"
  >
    <base-thumbnail
      class="thumbnail"
      medium
      :src="image"
    />
    <div
      class="collateral-item__icon"
    >
      <base-icon :icon="selected? 'selected' : 'selected_blank'" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollateralItem',
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    image: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.collateral-item {
  cursor: pointer;
  position: relative;

  &--selected {
    box-shadow: 0 0 0 2px $primary;
  }

  &__icon {
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    // background-color: $primary;
    top: 5px;
    right: 5px;
    border-radius: 20px;
    color: white;
    font-size: 0.75rem;
    text-align: center;
    // padding: 0.2rem;
    img{
      width: 11px;
      position: relative;
      left: -0.5px;
    }
  }

  &::v-deep .thumbnail img {
    width: 100%;
    object-fit: cover;
  }
}
.collateral-item__icon img{
  width: 18px;
}
</style>
